import React from 'react'
import qs from 'qs'
import { useLocation, useHistory } from 'react-router'

import LoadingSpinner from '../../components/atoms/LoadingSpinner'

import { Routes } from '../../Routes'
import {
  getStoredAccount,
  setStoredAccount
} from '../../providers/AccountProvider'

const PushNotificationPage = () => {
  const location = useLocation()
  const history = useHistory()

  React.useEffect(() => {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true })
    const {
      accountID,
      session,
      userID,
      isUser,
      isGroup,
      isConvo,
      isTask,
      sourceID
    } = params

    if (accountID) {
      // Change accounts if needed
      const oldAccount = getStoredAccount()
      if (oldAccount !== accountID) {
        setStoredAccount(accountID)
      }

      // Remove accout ID from url and refresh
      const newParams = { ...params }
      delete newParams.accountID
      const newURL = `${Routes.PUSH_NOTIFICATION}${qs.stringify(newParams, {
        encode: false,
        addQueryPrefix: true
      })}`
      history.replace(newURL)
    }

    // Redirect to task details
    if (isTask) {
      history.replace(`${Routes.TASKS}/${sourceID}`)
      return
    }

    // Redirect to new route
    const route = isConvo ? Routes.CLIENT_CHATS : Routes.PEER_CHAT
    let id = ''
    if (isConvo || isGroup) {
      id = session
    } else {
      id = userID
    }
    const userSuffix = isUser ? '&isUser' : ''

    history.replace(`${route}?session=${id}${userSuffix}`)
  }, [location, history])

  return <LoadingSpinner />
}

export default PushNotificationPage
